import { helpEs } from "./help.es";
export const languageSpanish = {
    modelPresetToolUse: "Uso de herramientas",
    modelPresetToolUseHelp: "Permite que este preajuste use las herramientas configuradas (MCP). Desactivado por defecto. Las ejecuciones de herramientas se envían sin streaming.",
    "formating": {
        "main": "Prompt Principal",
        "jailbreak": "Prompt Jailbreak",
        "chats": "Chats Anteriores",
        "lorebook": "Libro de Lore",
        "globalNote": "Nota Global",
        "authorNote": "Nota del Autor",
        "lastChat": "Último Chat",
        "description": "Descripción del Personaje",
        "personaPrompt": "Prompt de Persona",
        "plain": "Prompt Simple",
        "memory": "Supa/HypaMemoria",
        "postEverything": "Prompts Inyectados al Final"
    },
    "errors": {
        "toomuchtoken": "Error: El mínimo requerido de tokens es mayor que el Tamaño Máximo del Contexto.",
        "unknownModel": "Error: Modelo seleccionado desconocido",
        "httpError": "Error: error en la solicitud:",
        "noData": "Ese archivo no parece válido o sus datos están dañados.",
        "onlyOneChat": "Debe haber al menos un chat",
        "noUserIcon": "Debes establecer tu icono primero.",
        "emptyText": "El texto está vacío.",
        "wrongPassword": "Contraseña incorrecta",
        "networkFetch": "Esto ocurre cuando la red es inestable o el servidor está caído.",
        "networkFetchWeb": "Esto puede ser un error de CORS. Esto solo ocurre al usar la versión web debido a las limitaciones del navegador. Intenta usar la versión local de escritorio u otra versión de RisuBard.",
        "networkFetchPlain": "Esto puede ser un error de fetch simple. Intenta desactivar la opción de forzar fetch simple en la configuración.",
        "requestLogRemoved": "Este registro de solicitud ha sido eliminado.",
        "requestLogRemovedDesc": "Este registro de solicitud se elimina cuando el cliente se actualiza o recarga.",
        "vertexAuthError": "Faltan los detalles de autenticación de Vertex AI.",
        "coldStorageWriteFailed": "Error al escribir en almacenamiento frío. Sus datos de chat se han conservado.",
        "coldStorageVerifyFailed": "Error en la verificación del almacenamiento frío. Sus datos de chat se han conservado."
    },
    "showHelp": "Mostrar Ayuda",
    help: helpEs,
    "setup": {
        "chooseProvider": "Elige Proveedor de IA",
        "openaikey": "OpenAI con Clave API (Recomendado)",
        "openaiProxy": "Proxy Inverso de OpenAI",
        "setupmodelself": "Otros / Lo configuraré yo mismo",
        "inputApiKey": "Ingresa la Clave API Aquí",
        "apiKeyhelp": "Puedes obtener la clave API en: ",
        "setupSelfHelp": "Configúralo tú mismo en la configuración, después de que termine la pantalla de bienvenida.",
        "theme": "Selecciona tu tema",
        "themeDescWifulike": "No apto para móviles",
        "themeDescWifuCut": "Apto para móviles",
        "themeDescClassic": "Apto para todos los dispositivos",
        "texttheme": "Selecciona el color del texto",
        "inputName": "Por último, ingresa tu apodo.",
        "welcome": "¡Bienvenido a RisuBard! Aquí te guiaré para configurarlo. Primero, ¿cómo puedo llamarte?",
        "welcome2": "Hola {username}! Antes de empezar, te haré algunas preguntas. Puedes cambiar estas configuraciones más tarde en la configuración.\n\nPrimero selecciona el proveedor de IA.",
        "openRouterProvider": "OpenRouter tiene muchos modelos, algunos de ellos sin filtro y algunos gratuitos, pero no es tan bueno como OpenAI.",
        "hordeProvider": "Horde es un proveedor gratuito, pero el tiempo de respuesta es largo y la calidad es baja.",
        "setProviderLater": "Hay otros proveedores, pero puedes configurarlo más tarde en la configuración. selecciona esto si deseas configurarlo más tarde.",
        "setupOpenAI": "Para usar OpenAI, necesitas obtener una clave API. \n1. ve a https://beta.openai.com/ \n2. inicia sesión con tu cuenta \n3. ve a https://beta.openai.com/account/api-keys \n4. haz clic en 'Crear Nueva Clave API' y nombra tu clave como quieras. \n5. copia la clave en el sitio web.\n6. regresa a RisuBard\n7. pégala y haz clic en el botón enviar.",
        "setupClaude": "Para usar Claude, necesitas obtener una clave API.",
        "setupClaudeSteps": [
            "Ve a esta URL e inicia sesión como Google",
            "Ingresa tu información y haz clic en 'Continuar'",
            "En la página de organización, simplemente ingresa cualquier nombre solo en el primer cuadro y haz clic en 'Crear cuenta'",
            "Presiona el botón 'Comprar créditos'",
            "Presiona el botón 'Completar configuración'",
            "Ingresa tal como en la imagen de arriba, excepto la sección de país, donde debes ingresar tu país. Luego presiona 'Continuar'",
            "Agrega tu método de pago y presiona 'Continuar'",
            "Después de que se haya registrado el pago, presiona 'Agregar fondos' y agrega fondos. Puedes agregar un mínimo de 5$, o puedes configurar la recarga automática.",
            "Después de agregar fondos, ve a la página del panel y presiona el botón 'Obtener claves API'",
            "Presiona el botón 'Crear clave API'",
            "Ingresa tal como en la imagen de arriba y presiona 'Agregar'",
            "Copia la clave, pégala aquí y envíala."
        ],
        "setupOpenRouter": "Para usar OpenRouter, necesitas obtener una clave API. \n1. ve a https://openrouter.ai/keys\n2. haz clic en 'Crear Clave'\n3. establece el nombre de la clave como quieras.\n4. copia la clave en el sitio web\n5. regresa a RisuBard\n6. pégala y haz clic en el botón enviar.",
        "allDone": "¡Todo listo! por favor, espera un momento.",
        "setupLaterMessage": "¡Bienvenido {username}! ¿Quieres que te guíe para configurar o lo harás tú mismo?",
        "setupMessageOption1": "Guíame para configurar",
        "setupMessageOption1Desc": "Recomendado para nuevos usuarios",
        "setupMessageOption2": "Lo configuraré yo mismo",
        "claudeDesc": "Claude es un modelo de IA creado por Anthropic, competidor de OpenAI. Es mejor que GPT si quieres usarlo en otros idiomas además del inglés.",
        "openAIDesc": "OpenAI GPT es un modelo de IA de alta calidad, pero es de pago y filtrado, y débil en otros idiomas que no sean inglés.",
        "chooseChatType": "¡Genial! Ahora selecciona el idioma del chat.",
        "chooseChatTypeOption1": "Todo en Inglés",
        "chooseChatTypeOption1Desc": "Esto hará que la IA use inglés y entrada/salida en inglés. Recomendado para hablantes de inglés.",
        "chooseChatTypeOption2": "Procesamiento en Inglés",
        "chooseChatTypeOption2Desc": "Esto hará que la IA use inglés internamente, pero la entrada/salida estará en tu idioma. Recomendado para hablantes no ingleses.",
        "chooseChatTypeOption3": "Sin Idioma Enfocado",
        "chooseChatTypeOption3Desc": "Esto hará que la IA use tu idioma internamente, pero esto podría reducir la calidad.",
        "chooseCheapOrMemory": "Por cierto, ¿prefieres memoria o economía?",
        "chooseCheapOrMemoryOption1": "Memoria",
        "chooseCheapOrMemoryOption1Desc": "Esto hará que la IA recuerde más, pero será bastante costoso.",
        "chooseCheapOrMemoryOption2": "Económico",
        "chooseCheapOrMemoryOption2Desc": "Esto hará que la IA recuerde menos, pero será más barato.",
        "chooseCheapOrMemoryOption3": "Equilibrado",
        "chooseCheapOrMemoryOption3Desc": "Esto hará que la IA recuerde más que en económico, pero menos que en memoria.",
        "chooseCheapOrMemoryOption4": "Ilimitado",
        "chooseCheapOrMemoryOption4Desc": "Esto hará que la IA recuerde casi todo, pero será muy costoso.",
        "finally": "Finalmente, ¿quieres habilitar herramientas avanzadas?",
        "finallyOption1": "Sí",
        "finallyOption1Desc": "Esto habilitará herramientas avanzadas, pero hará que la interfaz de usuario sea más compleja. Recomendado para usuarios avanzados.",
        "finallyOption2": "No",
        "finallyOption2Desc": "Esto deshabilitará las herramientas avanzadas y hará que la interfaz de usuario sea más simple. Recomendado para nuevos usuarios.",
        "igpPrompt": "Si el Prompt IGP no está en blanco, se ejecutará después de la solicitud del modelo principal, después de la ejecución del modelo principal, como un modelo de emoción, agregando el resultado después de la respuesta del modelo principal."
    },
    "triggerCategories": {
        "Special": "Especial",
        "Control": "Control",
        "Chat": "Chat",
        "Low Level": "Bajo Nivel",
        "Alert": "Alerta",
        "Lorebook V2": "Libro de Lore V2",
        "String": "Cadena",
        "Data": "Datos",
        "Array": "Matriz",
        "Others": "Otros",
        "Deprecated": "Obsoleto"
    },
    "triggerDesc": {
        "v2Header": "Encabezado",
        "v2HeaderDesc": "Encabezado",
        "v2If": "Si",
        "v2IfDesc": "Si {{source}} {{condition}} {{target}}",
        "v2Else": "Sino",
        "v2ElseDesc": "Sino",
        "v2EndIndent": "Fin de Sangría",
        "v2EndIndentDesc": "Fin de Sangría",
        "v2SetVar": "Establecer Variable",
        "v2SetVarDesc": "Establecer Variable {{var}} {{operator}} {{value}}",
        "v2Loop": "Bucle Infinito",
        "v2LoopDesc": "Bucle Infinito",
        "v2BreakLoop": "Romper Bucle",
        "v2BreakLoopDesc": "Romper Bucle",
        "v2RunTrigger": "Ejecutar Trigger",
        "v2RunTriggerDesc": "Ejecutar Trigger {{target}}",
        "v2ConsoleLog": "Registro de Consola",
        "v2ConsoleLogDesc": "Registro de Consola {{source}}",
        "v2StopTrigger": "Detener Trigger",
        "v2StopTriggerDesc": "Detener Trigger",
        "v2CutChat": "Cortar Chat",
        "v2CutChatDesc": "Cortar Chat desde {{start}} hasta {{end}}",
        "v2ModifyChat": "Modificar Chat",
        "v2ModifyChatDesc": "Modificar Chat en índice {{index}} con {{value}}",
        "v2SystemPrompt": "Agregar Prompt del Sistema",
        "v2SystemPromptDesc": "Agregar Prompt del Sistema en {{location}} con {{value}}",
        "v2Impersonate": "Enviar Chat",
        "v2ImpersonateDesc": "Enviar Chat como {{role}} con {{value}}",
        "v2Command": "Ejecutar Comando",
        "v2CommandDesc": "Ejecutar comando con {{value}}",
        "v2SendAIprompt": "Enviar Prompt de IA",
        "v2SendAIpromptDesc": "Enviar Prompt de IA",
        "v2ImgGen": "Generación de Imagen",
        "v2ImgGenDesc": "Generar imagen desde {{value}}, negativo desde {{negValue}} => {{outputVar}}",
        "v2CheckSimilarity": "Comprobar Similitud",
        "v2CheckSimilarityDesc": "Comprobar similitud entre {{source}} y {{value}} => {{outputVar}}",
        "v2RunLLM": "Ejecutar Modelo",
        "v2RunLLMDesc": "Enviar solicitud al modelo desde {{value}} => {{outputVar}}",
        "v2ShowAlert": "Mostrar Alerta",
        "v2ShowAlertDesc": "Mostrar alerta con {{value}}",
        "v2ExtractRegex": "Extraer Regex",
        "v2ExtractRegexDesc": "Extraer texto de {{value}} con regex {{regexType}} {{regex}} y flags {{flagsType}} {{flags}}, luego guardar resultado como {{resultType}} {{result}} => {{outputVar}}",
        "v2RegexTest": "Prueba Regex",
        "v2RegexTestDesc": "Probar {{value}} con regex {{regex}} y flags {{flags}} => {{outputVar}}",
        "v2GetLastMessage": "Obtener Último Mensaje",
        "v2GetLastMessageDesc": "Obtener Último Mensaje => {{outputVar}}",
        "v2GetMessageAtIndex": "Obtener Mensaje en Índice",
        "v2GetMessageAtIndexDesc": "Obtener Mensaje en Índice {{index}} => {{outputVar}}",
        "v2GetMessageCount": "Obtener Recuento de Mensajes",
        "v2GetMessageCountDesc": "Obtener Recuento de Mensajes => {{outputVar}}",
        "v2GetLorebook": "Obtener Libro de Lore",
        "v2GetLorebookDesc": "Obtener Libro de Lore llamado {{target}} => {{outputVar}}",
        "v2GetLorebookCount": "Obtener Recuento de Libro de Lore",
        "v2GetLorebookCountDesc": "Obtener Recuento de Libro de Lore => {{outputVar}}",
        "v2GetLorebookEntry": "Obtener Entrada de Libro de Lore",
        "v2GetLorebookEntryDesc": "Obtener Libro de Lore con índice {{index}} => {{outputVar}}",
        "v2SetLorebookActivation": "Establecer Activación de Libro de Lore",
        "v2SetLorebookActivationDesc": "Establecer estado de activación del Libro de Lore con índice {{index}} a {{value}}",
        "v2GetLorebookIndexViaName": "Obtener Índice de Libro de Lore por Nombre",
        "v2GetLorebookIndexViaNameDesc": "Obtener Índice de Libro de Lore por Nombre {{name}} => {{outputVar}}",
        "v2ModifyLorebook": "Modificar Libro de Lore",
        "v2ModifyLorebookDesc": "Modificar Libro de Lore llamado {{target}} con {{value}}",
        "v2LoopNTimes": "Bucle N Veces",
        "v2LoopNTimesDesc": "Bucle {{value}} Veces",
        "v2Random": "Aleatorio",
        "v2RandomDesc": "Aleatorio desde {{min}} hasta {{max}} => {{outputVar}}",
        "v2GetCharAt": "Obtener Carácter en Índice",
        "v2GetCharAtDesc": "Obtener Carácter en Índice {{index}} de {{source}} => {{outputVar}}",
        "v2GetCharCount": "Obtener Recuento de Caracteres",
        "v2GetCharCountDesc": "Obtener Recuento de Caracteres de {{source}} => {{outputVar}}",
        "v2ToLowerCase": "Convertir a Minúsculas",
        "v2ToLowerCaseDesc": "Convertir {{source}} a Minúsculas => {{outputVar}}",
        "v2ToUpperCase": "Convertir a Mayúsculas",
        "v2ToUpperCaseDesc": "Convertir {{source}} a Mayúsculas => {{outputVar}}",
        "v2SetCharAt": "Establecer Carácter en Índice",
        "v2SetCharAtDesc": "Establecer Carácter en Índice {{index}} en {{source}} a {{value}} => {{outputVar}}",
        "v2SplitString": "Dividir Cadena",
        "v2SplitStringDesc": "Dividir {{source}} por {{delimiter}} => {{outputVar}}",
        "v2GetCharacterDesc": "Obtener Descripción del Personaje",
        "v2GetCharacterDescDesc": "Obtener Descripción del Personaje => {{outputVar}}",
        "v2SetCharacterDesc": "Establecer Descripción del Personaje",
        "v2SetCharacterDescDesc": "Establecer Descripción del Personaje a {{value}}",
        "v2GetPersonaDesc": "Obtener Prompt de Persona",
        "v2GetPersonaDescDesc": "Obtener Prompt de Persona => {{outputVar}}",
        "v2SetPersonaDesc": "Establecer Prompt de Persona",
        "v2SetPersonaDescDesc": "Establecer Prompt de Persona a {{value}}",
        "v2GetReplaceGlobalNote": "Obtener Nota Global de Reemplazo",
        "v2GetReplaceGlobalNoteDesc": "Obtener Nota Global de Reemplazo => {{outputVar}}",
        "v2SetReplaceGlobalNote": "Establecer Nota Global de Reemplazo",
        "v2SetReplaceGlobalNoteDesc": "Establecer Nota Global de Reemplazo a {{value}}",
        "v2GetAuthorNote": "Obtener Nota del Autor",
        "v2GetAuthorNoteDesc": "Obtener Nota del Autor => {{outputVar}}",
        "v2SetAuthorNote": "Establecer Nota del Autor",
        "v2SetAuthorNoteDesc": "Establecer Nota del Autor a {{value}}",
        "v2Comment": "Agregar Comentario",
        "v2CommentDesc": "{{value}}",
        "v2DeclareLocalVar": "Declarar Variable Local",
        "v2DeclareLocalVarDesc": "Declarar variable local {{var}} con valor {{value}}",
        "v2MakeArrayVar": "Crear Variable de Matriz",
        "v2MakeArrayVarDesc": "Crear Variable de Matriz {{var}}",
        "v2GetArrayVarLength": "Obtener Longitud de Variable de Matriz",
        "v2GetArrayVarLengthDesc": "Obtener Longitud de Variable de Matriz {{var}} => {{outputVar}}",
        "v2GetArrayVar": "Obtener Variable de Matriz",
        "v2GetArrayVarDesc": "Obtener Valor en Índice {{index}} de Variable de Matriz {{var}} => {{outputVar}}",
        "v2SetArrayVar": "Establecer Variable de Matriz",
        "v2SetArrayVarDesc": "Establecer Valor en Índice {{index}} en Variable de Matriz {{var}} a {{value}}",
        "v2PushArrayVar": "Agregar a Variable de Matriz",
        "v2PushArrayVarDesc": "Agregar {{value}} a Variable de Matriz {{var}}",
        "v2PopArrayVar": "Eliminar y obtener último valor de Variable de Matriz",
        "v2PopArrayVarDesc": "Eliminar último valor de Variable de Matriz {{var}} => {{outputVar}}",
        "v2ShiftArrayVar": "Eliminar y obtener primer valor de Variable de Matriz",
        "v2ShiftArrayVarDesc": "Eliminar primer valor de Variable de Matriz {{var}} => {{outputVar}}",
        "v2UnshiftArrayVar": "Agregar a Variable de Matriz como primer valor",
        "v2UnshiftArrayVarDesc": "Agregar {{value}} como primer valor de Variable de Matriz {{var}}",
        "v2SpliceArrayVar": "Agregar a Variable de Matriz en Índice",
        "v2SpliceArrayVarDesc": "Agregar {{value}} como valor {{start}} de Variable de Matriz {{var}}",
        "v2SliceArrayVar": "Rebanar Variable de Matriz",
        "v2SliceArrayVarDesc": "Rebanar Variable de Matriz {{var}} desde {{start}} hasta {{end}} => {{outputVar}}",
        "v2GetIndexOfValueInArrayVar": "Obtener Índice de Valor en Variable de Matriz",
        "v2GetIndexOfValueInArrayVarDesc": "Obtener Índice de {{value}} en Variable de Matriz {{var}} => {{outputVar}}",
        "v2RemoveIndexFromArrayVar": "Eliminar Índice de Variable de Matriz",
        "v2RemoveIndexFromArrayVarDesc": "Eliminar Valor en Índice {{index}} de Variable de Matriz {{var}}",
        "v2JoinArrayVar": "Unir Matriz",
        "v2JoinArrayVarDesc": "Unir Matriz {{var}} con {{delimiter}} => {{outputVar}}",
        "v2MakeDictVar": "Crear Variable de Diccionario",
        "v2MakeDictVarDesc": "Crear Variable de Diccionario {{var}}",
        "v2GetDictVar": "Obtener Valor de Diccionario",
        "v2GetDictVarDesc": "Obtener Valor para Clave {{key}} de Diccionario {{var}} => {{outputVar}}",
        "v2SetDictVar": "Establecer Valor de Diccionario",
        "v2SetDictVarDesc": "Establecer Valor para Clave {{key}} en Diccionario {{var}} a {{value}}",
        "v2DeleteDictKey": "Eliminar Clave de Diccionario",
        "v2DeleteDictKeyDesc": "Eliminar Clave {{key}} de Diccionario {{var}}",
        "v2HasDictKey": "Tiene Clave de Diccionario",
        "v2HasDictKeyDesc": "Comprobar si Diccionario {{var}} tiene Clave {{key}} => {{outputVar}}",
        "v2ClearDict": "Limpiar Diccionario",
        "v2ClearDictDesc": "Limpiar Diccionario {{var}}",
        "v2GetDictSize": "Obtener Tamaño de Diccionario",
        "v2GetDictSizeDesc": "Obtener Tamaño de Diccionario {{var}} => {{outputVar}}",
        "v2GetDictKeys": "Obtener Claves de Diccionario",
        "v2GetDictKeysDesc": "Obtener Todas las Claves de Diccionario {{var}} => {{outputVar}}",
        "v2GetDictValues": "Obtener Valores de Diccionario",
        "v2GetDictValuesDesc": "Obtener Todos los Valores de Diccionario {{var}} => {{outputVar}}",
        "v2ConcatString": "Concatenar Cadenas",
        "v2ConcatStringDesc": "Concatenar {{source1}} y {{source2}} => {{outputVar}}",
        "v2GetLastUserMessage": "Obtener Último Mensaje de Usuario",
        "v2GetLastUserMessageDesc": "Obtener Último Mensaje de Usuario => {{outputVar}}",
        "v2GetLastCharMessage": "Obtener Último Mensaje de Personaje",
        "v2GetLastCharMessageDesc": "Obtener Último Mensaje de Personaje => {{outputVar}}",
        "v2GetFirstMessage": "Obtener Primer Mensaje",
        "v2GetFirstMessageDesc": "Obtener Primer Mensaje => {{outputVar}}",
        "v2GetAlertInput": "Obtener Entrada de Alerta",
        "v2GetAlertInputDesc": "Obtener Entrada de Alerta => {{outputVar}}",
        "v2GetAlertSelect": "Obtener Selección de Alerta",
        "v2GetAlertSelectDesc": "Obtener Selección de Alerta {{display}} opciones {{value}} => {{outputVar}}",
        "v2UnsupportedTrigger": "Trigger No Soportado",
        "v2UnsupportedTriggerDesc": "Trigger No Soportado",
        "v2GetDisplayState": "Obtener Estado de Visualización",
        "v2GetDisplayStateDesc": "Obtener Estado de Visualización => {{outputVar}}",
        "v2SetDisplayState": "Establecer Estado de Visualización",
        "v2SetDisplayStateDesc": "Establecer Estado de Visualización a {{value}}",
        "v2UpdateGUI": "Actualizar GUI",
        "v2UpdateGUIDesc": "Actualizar GUI",
        "v2UpdateChatAt": "Actualizar Chat en Índice",
        "v2UpdateChatAtDesc": "Redibujar chat en {{index}}",
        "v2Wait": "Esperar",
        "v2WaitDesc": "Esperar {{value}} segundos",
        "v2GetRequestState": "Obtener Contenido de Datos de Solicitud",
        "v2GetRequestStateDesc": "Obtener Contenido de Solicitud en {{index}} => {{outputVar}}",
        "v2SetRequestState": "Establecer Contenido de Datos de Solicitud",
        "v2SetRequestStateDesc": "Establecer Contenido de Solicitud en {{index}} a {{value}}",
        "v2GetRequestStateRole": "Obtener Rol de Datos de Solicitud",
        "v2GetRequestStateRoleDesc": "Obtener Rol de Datos de Solicitud en {{index}} => {{outputVar}}",
        "v2SetRequestStateRole": "Establecer Rol de Datos de Solicitud",
        "v2SetRequestStateRoleDesc": "Establecer Rol de Datos de Solicitud en {{index}} a {{value}}",
        "v2GetRequestStateLength": "Obtener Longitud de Datos de Solicitud",
        "v2GetRequestStateLengthDesc": "Obtener Longitud de Datos de Solicitud => {{outputVar}}",
        "v2IfAdvanced": "Si",
        "v2IfAdvancedDesc": "Si {{source}} {{condition}} {{target}}",
        "v2QuickSearchChat": "Búsqueda Rápida en Chat",
        "v2QuickSearchChatDesc": "Búsqueda rápida {{value}} en chat con condición {{condition}} en profundidad {{depth}} => {{outputVar}}",
        "v2StopPromptSending": "Detener Envío de Prompt",
        "v2StopPromptSendingDesc": "Detener Envío de Prompt",
        "v2Tokenize": "Tokenizar",
        "v2TokenizeDesc": "Tokenizar {{value}} => {{outputVar}}",
        "v2GetAllLorebooks": "Obtener Todos los Libros de Lore",
        "v2GetAllLorebooksDesc": "Obtener todos los prompts de libros de lore como matriz => {{outputVar}}",
        "v2GetLorebookByName": "Obtener Índices de Libro de Lore por Nombre",
        "v2GetLorebookByNameDesc": "Obtener matriz de índices de libros de lore por nombre {{name}} => {{outputVar}}",
        "v2GetLorebookByIndex": "Obtener Libro de Lore",
        "v2GetLorebookByIndexDesc": "Obtener prompt de libro de lore en índice {{index}} => {{outputVar}}",
        "v2CreateLorebook": "Crear Libro de Lore",
        "v2CreateLorebookDesc": "Crear libro de lore con nombre {{name}}, clave {{key}}, contenido {{content}}",
        "v2ModifyLorebookByIndex": "Modificar Libro de Lore",
        "v2ModifyLorebookByIndexDesc": "Modificar libro de lore en índice {{index}} con nombre {{name}}, clave {{key}}, contenido {{content}}",
        "v2DeleteLorebookByIndex": "Eliminar Libro de Lore",
        "v2DeleteLorebookByIndexDesc": "Eliminar libro de lore en índice {{index}}",
        "v2GetLorebookCountNew": "Obtener Recuento de Libro de Lore",
        "v2GetLorebookCountNewDesc": "Obtener recuento total de libros de lore => {{outputVar}}",
        "v2SetLorebookAlwaysActive": "Establecer Libro de Lore Siempre Activo",
        "v2SetLorebookAlwaysActiveDesc": "Establecer libro de lore en índice {{index}} siempre activo a {{value}}",
        "v2Calculate": "Calcular",
        "v2CalculateDesc": "Calcular {{expression}} => {{outputVar}}",
        "v2ReplaceString": "Reemplazar Cadena",
        "v2ReplaceStringDesc": "Reemplazar {{source}} con regex {{regex}} a {{replacement}} => {{outputVar}}"
    },
    "triggerInputLabels": {
        "value": "Valor",
        "var": "Variable",
        "varName": "Nombre de Variable",
        "outputVar": "Variable de Salida",
        "name": "Nombre",
        "index": "Índice",
        "source": "Fuente",
        "target": "Objetivo",
        "condition": "Condición",
        "operator": "Operador",
        "role": "Rol",
        "location": "Ubicación",
        "prompt": "Prompt",
        "model": "Modelo",
        "start": "Inicio",
        "end": "Fin",
        "min": "Mín",
        "max": "Máx",
        "delimiter": "Delimitador",
        "depth": "Profundidad",
        "key": "Clave",
        "alertContent": "Contenido de Alerta",
        "options": "Opciones",
        "cmd": "Comando",
        "regex": "Regex",
        "replacement": "Reemplazo",
        "flags": "Banderas",
        "negPrompt": "Prompt Negativo",
        "resultFormat": "Formato de Resultado",
        "activationKeys": "Claves de Activación",
        "insertOrder": "Orden de Inserción",
        "sysStart": "Inicio del Sistema",
        "sysHistoryEnd": "Fin del Historial del Sistema",
        "sysPromptEnd": "Fin del Prompt del Sistema",
        "addElse": "Agregar Sino",
        "alwaysActive": "Siempre Activo",
        "trigger": "Trigger",
        "triggerOn": "Trigger Activado",
        "valueTypeDesc": "Usar valor de entrada directamente",
        "varTypeDesc": "Usar valor almacenado en variable",
        "conditionEqual": "Igual (=)",
        "conditionNotEqual": "No Igual (≠)",
        "conditionGreater": "Mayor (>)",
        "conditionLess": "Menor (<)",
        "conditionGreaterEqual": "Mayor o Igual (≥)",
        "conditionLessEqual": "Menor o Igual (≤)",
        "conditionSimilar": "Similar (≒)",
        "conditionContains": "Contiene (∋)",
        "conditionIn": "En (∈)",
        "conditionNotContains": "No Contiene (∌)",
        "conditionNotIn": "No En (∉)",
        "conditionTruthy": "Verdadero (≡)",
        "operatorSet": "Establecer (=)",
        "operatorAdd": "Agregar (+=)",
        "operatorSubtract": "Restar (-=)",
        "operatorMultiply": "Multiplicar (*=)",
        "operatorDivide": "Dividir (/=)",
        "operatorModulo": "Módulo (%=)",
        "searchLoose": "Búsqueda Flexible",
        "searchStrict": "Búsqueda Estricta",
        "searchRegex": "Búsqueda Regex",
        "modelMain": "Modelo Principal",
        "modelSub": "Modelo Auxiliar",
        "roleUser": "Usuario",
        "roleChar": "Personaje",
        "roleSystem": "Sistema",
        "roleAssistant": "Asistente",
        "boolTrue": "Verdadero",
        "boolFalse": "Falso",
        "boolNull": "Nulo",
        "helpVarName": "Ingresa el nombre de la variable",
        "helpOutputVar": "Ingresa el nombre de la variable para almacenar el resultado",
        "helpIndex": "Número de índice de matriz o mensaje",
        "helpRegex": "Ingresa el patrón regex",
        "helpFlags": "Banderas Regex",
        "helpDelimiter": "Delimitador para dividir la cadena",
        "helpActivationKeys": "Palabras clave de activación separadas por comas",
        "helpInsertOrder": "Orden de inserción",
        "helpDepth": "Profundidad de mensajes para buscar",
        "helpMinMax": "Rango de valor mínimo y máximo",
        "helpSlot": "Usa {{slot}} para mantener sin cambios",
        "expression": "Expresión"
    },
    "playground": {
        "playground": "Playground",
        "inlayDeleteConfirm": "¿Estás seguro de que deseas eliminar \"{name}\"?",
        "inlayDeleteMultipleConfirm": "¿Estás seguro de que deseas eliminar los {count} recursos seleccionados?",
        "inlayDeleteSelected": "Eliminar seleccionados",
        "inlayDeselectAll": "Deseleccionar todo",
        "inlayEmpty": "Sin recursos inlay guardados",
        "inlayEmptyDesc": "Las imágenes, audios y videos adjuntos o generados en chats aparecerán aquí",
        "inlayExplorer": "Explorador de Recursos Inlay",
        "inlayImageGallery": "Galería de Imágenes Inlay",
        "inlayImageGalleryEmptyDesc": "Las imágenes adjuntas o generadas en chats aparecerán aquí",
        "inlaySelectAll": "Seleccionar todo",
        "inlayTotalAssets": "Total {count} recursos",
        "inlayDelete": "Delete",
        "inlayLoadingMore": "Loading...",
        "inlayCreatedAt": "Created:",
        "inlayUpdatedAt": "Updated:",
        "inlaySort": "Sort",
        "inlaySortUpdatedDesc": "Updated ↓",
        "inlaySortUpdatedAsc": "Updated ↑",
        "inlaySortCreatedDesc": "Created ↓",
        "inlaySortCreatedAsc": "Created ↑",
        "inlayFilter": "Filter",
        "inlayFilterAll": "All",
        "inlayFilterMetaMissing": "Meta Missing",
        "inlayFilterOrphanCharacter": "Orphan Character",
        "inlayFilterOrphanChat": "Orphan Chat",
        "inlayOriginalLoadNeeded": "Original Load Needed",
        "inlayAudioAsset": "Audio Asset",
        "inlayVideoAsset": "Video Asset",
        "inlaySignatureAsset": "Signature Asset",
        "inlayInfo": "Info",
        "inlayManualMapping": "Manual Mapping",
        "inlayActions": "Actions",
        "inlayLoadingOriginal": "Loading original image...",
        "inlaySave": "Save",
        "inlaySaved": "Saved!",
    },
    "confirm": "Confirmar",
    "yes": "Sí",
    "no": "No",
    "goback": "Volver",
    "botSettings": "Configuración del Bot",
    "model": "Modelo",
    "apiKey": "Clave API",
    "providerURL": "URL de Solicitud",
    "providerJSON": "Cuerpo JSON de la Solicitud",
    "mainPrompt": "Prompt Principal",
    "jailbreakPrompt": "Prompt Jailbreak",
    "globalNote": "Nota Global",
    "autoSuggest": "Auto Sugerir",
    "tokens": "Tokens",
    "maxContextSize": "Tamaño Máximo del Contexto",
    "maxResponseSize": "Tamaño Máximo de la Respuesta",
    "temperature": "Temperatura",
    "frequencyPenalty": "Penalización por Frecuencia",
    "presensePenalty": "Penalización por Presencia",
    "advancedSettings": "Configuraciones Avanzadas",
    "advancedSettingsWarn": "Advertencia: ¡Si no sabes lo que hace la opción, no la cambies!",
    "formatingOrder": "Orden de Formateo",
    "authorNote": "Nota del Autor",
    "firstMessage": "Primer Mensaje",
    "description": "Descripción",
    "note": "Nota",
    "jailbreakToggle": "Alternar Jailbreak",
    "charIcon": "Icono del Personaje",
    "characterDisplay": "Pantalla del Personaje",
    "viewScreen": "Pantalla Adicional del Personaje",
    "none": "Ninguno",
    "emotionImage": "Imágenes de Emoción",
    "noImages": "Sin Imágenes",
    "noBias": "Sin Bias",
    "image": "Imagen",
    "name": "Nombre",
    "folderName": "Nombre de la Carpeta",
    "folderRemoveConfirm": "Esta carpeta contiene libros de lore. ¿Estás seguro de que quieres eliminarla y todo su contenido?",
    "emotion": "Nombre de la Emoción",
    "value": "Valor",
    "reroll": "Regenerar",
    "deleteRerollMessage": "Eliminar mensaje regenerado",
    "deleteRerollMessageConfirm": "¿Eliminar el mensaje regenerado seleccionado?",
    "rerollConfirm": "¿Generar un nuevo mensaje y añadirlo a la lista?",
    "noSwipesRerollConfirm": "No hay mensajes regenerados adicionales. ¿Generar un nuevo mensaje y añadirlo a la lista?",
    "chatList": "Lista de Chats",
    "removeChat": "¿Eliminar este mensaje?",
    "loreBook": "Libro de Lore",
    "character": "Personaje",
    "Chat": "Chat",
    "globalLoreInfo": "El Libro de Lore del Personaje se aplica a todos los chats del personaje.",
    "group": "Grupo",
    "localLoreInfo": "El Libro de Lore del Chat solo se aplica al chat actual.",
    "removeConfirm": "¿Realmente deseas eliminar: ",
    "removeConfirm2": "¿REALMENTE deseas eliminar: ",
    "exportConfirm": "¿Deseas exportar esto?",
    "insertOrder": "Orden de Inserción",
    "activationKeys": "Claves de Activación",
    "activationKeysInfo": "Separado por comas",
    "prompt": "Prompt",
    "loreBookDepth": "Profundidad de Búsqueda del Libro de Lore",
    "loreBookToken": "Máximo de Tokens del Libro de Lore",
    "removeCharacter": "Eliminar Personaje",
    "exportCharacter": "Exportar Personaje",
    "userSetting": "Configuración de Usuario",
    "username": "Tu Nombre",
    "userIcon": "Tu Icono",
    "successExport": "Exportado y descargado exitosamente en tu directorio de descargas",
    "successImport": "Importado exitosamente",
    "moduleCreated": "Módulo creado.",
    "moduleUpdated": "Módulo actualizado.",
    "moduleDeleted": "Módulo eliminado.",
    "importedCharacter": "Personaje Importado",
    "alwaysActive": "Siempre Activo",
    "additionalPrompt": "Prompt Adicional",
    "descriptionPrefix": "Prefijo de Descripción",
    "forceReplaceUrl": "Proxy Inverso",
    "emotionWarn": "Se usa modelo auxiliar.",
    "plugin": "Plugin",
    "language": "Idioma",
    "UiLanguage": "Idioma de la Interfaz",
    "createfromScratch": "Crear desde Cero",
    "importCharacter": "Importar Personaje",
    "translator": "Traductor",
    "disabled": "Deshabilitado",
    "noPluginSelected": "Modelo seleccionado como plugin, pero no se seleccionó ningún plugin.",
    "text": "Texto",
    "UISize": "Tamaño del Texto del Chat",
    "newVersion": "Se encontró una actualización, ¿deseas instalarla?",
    "remindLaterQuestion": "¿Cuándo debo recordarte?",
    "remindIgnore": "Ignorar",
    "remindLater1Day": "Recordar en 1 día",
    "remindLater3Days": "Recordar en 3 días",
    "remindLater5Days": "Recordar en 5 días",
    "remindLater1Week": "Recordar en 1 semana",
    "display": "Pantalla y Audio",
    "useCustomBackground": "Fondo Personalizado",
    "translateInput": "Traducir Entrada",
    "autoTranslation": "Traducción Automática",
    "fullscreen": "Pantalla Completa",
    "playMessage": "Reproducir Audio del Mensaje",
    "iconSize": "Tamaño del Icono",
    "single": "Único",
    "multiple": "Múltiple",
    "useCharLorebook": "Usar Lores en Personajes",
    "selectChar": "Seleccionar Personaje",
    "askLoadFirstMsg": "¿Cargamos el primer mensaje?",
    "theme": "Tema",
    "editOrder": "Editar Orden",
    "submodel": "Modelo Auxiliar",
    "timeOutinSec": "Tiempo de Espera (en segundos)",
    "emotionPrompt": "Prompt de Emoción",
    "singleView": "Vista Única",
    "SpacedView": "Vista de Múltiples Personajes",
    "emphasizedView": "Vista de Personajes Doble",
    "pluginWarn": "Instalar plugins maliciosos puede causar problemas.",
    "pluginConfirm": "¿Realmente quieres importar este plugin? Solo importa plugins de fuentes confiables.",
    "pluginContainsExternalMedia": "Este plugin contiene medios externos.",
    "pluginContainsExternalJS": "Este complemento contiene Javascript externo.",
    "waifuWidth": "Ancho del Chat Waifu",
    "files": "Archivos",
    "backupConfirm": "¿Realmente deseas guardar el respaldo?",
    "backupLoadConfirm": "¿Realmente deseas cargar el respaldo? ¡Todos los datos se perderán!",
    "backupLoadConfirm2": "¿Realmente, realmente deseas cargar el respaldo? ¡Todos los datos se perderán!",
    "others": "Otros",
    "presets": "Presets",
    "imageGeneration": "Generación de Imágenes",
    "provider": "Proveedor",
    "key": "Clave",
    "noData": "Sin Datos",
    "currentImageGeneration": "Datos Actuales de Generación de Imágenes",
    "promptPreprocess": "Usar Preprocesamiento de Prompt",
    "SwipeRegenerate": "Usar Swipe para Regeneración",
    "removeMessageOnly": "Eliminar solo este mensaje",
    "removeMessageAndAfter": "Eliminar este y los mensajes posteriores ({})",
    "messageRemoved": "Mensaje eliminado",
    "messagesRemoved": "{} mensajes eliminados",
    "confirmReroll": "Confirmar al Regenerar Mensaje",
    "textColor": "Color del Texto",
    "classicRisu": "Risu Clásico",
    "highcontrast": "Alto Contraste",
    "requestretrys": "Reintentos de Solicitud al Fallar",
    "utilityBot": "Bot de Utilidad",
    "waifuWidth2": "Tamaño del Personaje Waifu",
    "sayNothing": "Ingresar 'no decir nada' cuando no se haya ingresado ninguna cadena",
    "regexScript": "Script Regex",
    "type": "Tipo",
    "editInput": "Modificar Entrada",
    "editOutput": "Modificar respuesta",
    "editProcess": "Modificar Datos de Solicitud",
    "loadLatest": "Cargar Respaldo más Reciente",
    "loadOthers": "Cargar Otros Respaldos",
    "exampleMessage": "Mensaje de Ejemplo",
    "creatorNotes": "Comentario del Creador",
    "systemPrompt": "Prompt del Sistema",
    "characterNotes": "Notas del Personaje",
    "personality": "Personalidad",
    "scenario": "Escenario",
    "alternateGreetings": "Saludos Alternativos",
    "unrecommended": "No Recomendado",
    "chatNotes": "Notas del Chat",
    "showUnrecommended": "Mostrar Configuraciones No Recomendadas",
    "altGreet": "Mensajes de Inicio Alternativos",
    "scripts": "Scripts",
    "settings": "Configuración",
    "selective": "Selectivo",
    "SecondaryKeys": "Claves Secundarias",
    "useGlobalSettings": "Usar Configuración Global",
    "recursiveScanning": "Escaneo Recursivo",
    "creator": "Creador",
    "CharVersion": "Versión del Personaje",
    "Speech": "Habla",
    "useExperimental": "Habilitar Funciones Experimentales",
    "showMemoryLimit": "Mostrar Límite de Memoria",
    "showFirstMessagePages": "Mostrar Páginas del Primer Mensaje",
    "roundIcons": "Iconos Redondos",
    "streaming": "Streaming",
    "chatBot": "Chat Bot",
    "otherBots": "Otros Bots",
    "user": "Usuario",
    "additionalAssets": "Activos Adicionales",
    "editDisplay": "Modificar Visualización",
    "textBackgrounds": "Color Personalizado de la Pantalla de Texto",
    "textBorder": "Contornos de Texto",
    "textScreenRound": "Pantalla de Texto Redondeada",
    "textScreenBorder": "Bordes de Pantalla de Texto",
    "ttsReadOnlyQuoted": "Leer Solo Citas",
    "ttsStop": "Detener TTS",
    "replaceGlobalNote": "Reemplazo de Nota Global",
    "charLoreBook": "Libro de Lore del Personaje",
    "globalLoreBook": "Libro de Lore Global",
    "globalRegexScript": "Regex Global",
    "accessibility": "Accesibilidad",
    "sendWithEnter": "Enviar con la Tecla Enter(Al desactivar la verificación, Shift + Enter cambia a Transmisión de Mensajes.)",
    "fixedChatTextarea": "Fijación en la parte inferior de la ventana de chat",
    "clickToEdit": "Haz Clic en el Texto para Editar",
    "setNodePassword": "Establece tu contraseña para la seguridad",
    "inputNodePassword": "Ingresa tu contraseña. si no la recuerdas, elimina save/__password.txt en tus archivos de servidor y reinicia el servidor.",
    "simple": "Simple",
    "advanced": "Avanzado",
    "askReRollAutoSuggestions": "Regenerar Auto Sugerencias",
    "creatingSuggestions": "Creando Sugerencias...",
    "active": "Activo",
    "loreRandomActivation": "Usar Condición de Probabilidad",
    "activationProbability": "Probabilidad",
    "hub": "RisuRealm",
    "tags": "Etiquetas",
    "backgroundHTML": "Incrustación de Fondo",
    "copied": "Copiado",
    "useChatCopy": "Usar Copia de Mensaje de Chat",
    "useChatSticker": "Usar Sticker de Chat",
    "useAdditionalAssetsPreview": "Usar Vista Previa de Activos Adicionales",
    "autoTranslateInput": "Traducción Automática de Entrada",
    "enterMessageForTranslateToEnglish": "Ingresa el Mensaje para Traducir al Inglés",
    "recent": "Reciente",
    "downloads": "Descargas",
    "trending": "Tendencias",
    "imageCompression": "Compresión de Imágenes",
    "notLoggedIn": "No has iniciado sesión en Risu",
    "SaveDataInAccount": "Guardar Datos en la Cuenta",
    "dataSavingInAccount": "Guardando Datos en la Cuenta",
    "logout": "Cerrar Sesión",
    "loadDataFromAccount": "Cargar Datos desde la Cuenta",
    "saveCurrentDataToAccount": "Guardar Datos Actuales en la Cuenta",
    "chatAssumed": "",
    "proxyAPIKey": "Clave/Contraseña del Proxy",
    "proxyRequestModel": "Modelo de Solicitud",
    "officialWiki": "Wiki Oficial",
    "officialWikiDesc": "Wiki Oficial de RisuBard. siéntete libre de consultarla.",
    "officialDiscord": "Discord Oficial",
    "officialDiscordDesc": "Discord Oficial para hablar sobre RisuBard",
    "persona": "Persona",
    "icon": "Icono",
    "account": "Cuenta",
    "remove": "Eliminar",
    "able": "Habilitar",
    "assetWidth": "Ancho Máximo de Imágenes de Activos",
    "animationSpeed": "Velocidad de Animación",
    "screenshot": "Captura de Pantalla",
    "screenshotSaved": "Captura de Pantalla Guardada",
    "createBotwithAI": "Crear Bot con IA",
    "changeFolderName": "Ingresa el nuevo nombre de la carpeta (deja en blanco para cancelar)",
    "cancel": "Cancelar",
    "renameFolder": "Renombrar Carpeta",
    "changeFolderColor": "Cambiar Color de Carpeta",
    "changeFolderImage": "Cambiar Imagen de Carpeta",
    "fullWordMatching": "Coincidencia Completa de Palabras",
    "botSettingAtStart": "Menú del Bot al Iniciar",
    "triggerStart": "Al enviar chat",
    "triggerInput": "Al enviar respuesta del usuario",
    "triggerOutput": "Al enviar respuesta del personaje",
    "triggerManual": "Solo activación manual",
    "triggerCondVar": "Si Variable",
    "triggerCondExists": "Si el Texto Existe en el Chat",
    "triggerScript": "Script de Activación",
    "triggerMatchRegex": "Coincidir con Regex",
    "triggerMatchLoose": "Coincidir Sin Restricciones",
    "triggerMatchStrict": "Coincidir Estrictamente",
    "searchDepth": "Profundidad de Búsqueda",
    "equal": "Igual a",
    "notEqual": "Diferente de",
    "greater": "Mayor que",
    "less": "Menor que",
    "greaterEqual": "Mayor o Igual que",
    "lessEqual": "Menor o Igual que",
    "triggerEffSysPrompt": "Agregar Prompt del Sistema",
    "triggerEffSetVar": "Modificar Variable",
    "triggerEffImperson": "Enviar Chat",
    "triggerEffCommand": "Ejecutar Comando",
    "triggerEffRunTrigger": "Ejecutar Activación",
    "triggerEffStop": "Detener Envío de Prompt",
    "triggerEffCall": "Llamar a Activación",
    "varableName": "Nombre de la Variable",
    "role": "Rol",
    "location": "Ubicación",
    "promptstart": "Inicio del Prompt",
    "promptend": "Fin del Prompt",
    "historyend": "Fin del Historial",
    "always": "Siempre",
    "noEffect": "Sin Efecto",
    "invaildTriggerEffect": "Este efecto no funciona para este tipo de activación.",
    "operator": "Operador",
    "TriggerSetToVar": "Asignar a Variable",
    "TriggerAddToVar": "Agregar a Variable",
    "TriggerSubToVar": "Restar a Variable",
    "TriggerMulToVar": "Multiplicar a Variable",
    "TriggerDivToVar": "Dividir de Variable",
    "isNull": "no está establecido",
    "ifChatIndex": "Si índice del chat",
    "ifRandom": "Si aleatorio",
    "ifValue": "Si valor",
    "hideRealm": "Iniciar RisuRealm contraído",
    "hideAllImages": "Ocultar todas las imágenes",
    "hideMessagePageCount": "Ocultar contador de páginas de mensajes",
    "popularityLevel": "{} Popularidad",
    "colorScheme": "Esquema de Colores",
    "rangeStart": "Inicio del Rango",
    "rangeEnd": "Fin del Rango",
    "untilChatEnd": "Hasta el Fin del Chat",
    "usePromptTemplate": "Usar Plantilla de Prompt",
    "specialType": "Tipo Especial",
    "noSpecialType": "Sin Tipo Especial",
    "forceProxyAsOpenAI": "Forzar Formato de Proxy como OpenAI",
    "promptTemplate": "Plantilla de Prompt",
    "customInnerFormat": "Formato Interno Personalizado",
    "innerFormat": "Formato Interno",
    "HypaMemory": "HypaMemoria",
    "ToggleHypaMemory": "Alternar HypaMemoria",
    "resetPromptTemplateConfirm": "¿Realmente deseas restablecer la plantilla de prompt?",
    "emotionMethod": "Método de Emoción",
    "continueResponse": "Continuar Respuesta",
    "showMenuChatList": "Mostrar Menú de Lista de Chats",
    "translatorLanguage": "Idioma del Traductor",
    "translatorType": "Tipo de Traductor",
    "htmlTranslation": "Traducción de HTML",
    "deeplKey": "Clave API de DeepL",
    "deeplFreeKey": "Clave API Gratis de DeepL",
    "deeplXUrl": "URL de DeepLX",
    "deeplXToken": "Token de DeepLX",
    "exportPersona": "Exportar Persona",
    "importPersona": "Importar Persona",
    "export": "Exportar",
    "import": "Importar",
    "useNamePrefix": "Usar Prefijo de Nombre",
    "textAdventureNAI": "Ejecutar como Aventura de Texto",
    "appendNameNAI": "Agregar Nombre en NAI",
    "customStopWords": "Palabras de Parada Personalizadas",
    "defaultPrompt": "Prompt Predeterminado",
    "additionalText": "Descripción Adicional",
    "seed": "Semilla",
    "charjs": "CharacterJS",
    "depthPrompt": "Prompt de Profundidad",
    "largePortrait": "Retrato",
    "reverseProxyOobaMode": "Modo Ooba",
    "exactTokens": "Tokens Exactos",
    "fixedTokens": "Tokens Aproximados",
    "inlayViewScreen": "Pantalla de Incrustación",
    "imgGenPrompt": "Prompt de Generación de Imágenes",
    "imgGenNegatives": "Prompt Negativo de Generación de Imágenes",
    "imgGenInstructions": "Instrucciones para Generación de Imágenes",
    "usePlainFetchWarn": "Desactiva esta opción cuando uses NovelAI, ya que puede causar errores de CORS al usar NovelAI.",
    "translationPrompt": "Prompt de Traducción",
    "translationResponseSize": "Tamaño de Respuesta de Traducción",
    "webdeeplwarn": "Esta opción no se recomienda para su uso con la versión web, ya que puede causar errores de CORS.",
    "saveBackupLocal": "Guardar Respaldo Localmente",
    "loadBackupLocal": "Cargar Respaldo Localmente",
    "topP": "Top P",
    "genTimes": "Opciones de Generación",
    "cot": "Cadena de Pensamientos",
    "forcePlainFetch": "Forzar Fetch Simple",
    "autoFillRequestURL": "Autocompletar URL de Solicitud",
    "newOAIHandle": "Nuevo Manejo de OpenAI",
    "inlayImage": "Característica de Incrustación de Imágenes",
    "nativeAutomark": "Automarcación Nativa Experimental",
    "assistantPrefill": "Relleno Automático del Asistente",
    "postEndInnerFormat": "Formato Interno Post Fin",
    "sendChatAsSystem": "Enviar Chat como Sistema",
    "sendName": "Enviar Nombre en Chat No Grupal",
    "utilOverride": "Anulación de Utilidad",
    "template": "Plantilla",
    "chatAsOriginalOnSystem": "Enviar como rol original",
    "exportAsDataset": "Exportar Guardado como Conjunto de Datos",
    "editTranslationDisplay": "Editar Visualización de Traducción",
    "selectModel": "Seleccionar Modelo",
    "autoRemoveThoughtTag": "Eliminar Etiqueta de Pensamiento",
    "customChainOfThought": "Cadena de Pensamientos Personalizada",
    "maxThoughtTagDepth": "Profundidad Máxima de Etiqueta de Pensamiento",
    "openRouterFallback": "Fallback de Openrouter",
    "openRouterMiddleOut": "Middle Out de Openrouter",
    "openRouterProviderOrder": "Orden de Preferencia del Proveedor",
    "openRouterProviderOnly": "Proveedores Permitidos",
    "openRouterProviderIgnore": "Proveedores Ignorados",
    "openRouterSearchModel": "Buscar modelos...",
    "openRouterSortByName": "Nombre",
    "openRouterSortByPrice": "Precio",
    "openRouterSortByProvider": "Proveedor",
    "openRouterSortAsc": "Ascendente",
    "openRouterSortDesc": "Descendente",
    "geminiApiKey": "Clave API de Gemini",
    "memoryLimitThickness": "Grosor del Límite de Memoria",
    "inputCardPassword": "Ingresa la Contraseña de la Tarjeta",
    "ccv2Desc": "Character Card V2 es un formato ampliamente utilizado en programas de chatbot.",
    "ccv3Desc": "Character Card V3 es un formato de próxima generación que se usa en programas de chatbot.",
    "rccDesc": "Risu Refined Character Card es un formato con características adicionales como contraseña, verificación de integridad, etc.",
    "password": "Contraseña",
    "license": "Licencia",
    "licenseDesc": "Puedes elegir la licencia para los descargadores para limitar los usos del prompt de tu tarjeta.",
    "passwordDesc": "Puedes establecer una contraseña para proteger tu tarjeta de accesos no autorizados.",
    "largePersonaPortrait": "Retrato de Persona",
    "module": "Módulo",
    "modules": "Módulos",
    "noModules": "No se han instalado módulos.",
    "createModule": "Crear Módulo",
    "basicInfo": "Información Básica",
    "moduleContent": "Contenido del Módulo",
    "confirmRemoveModuleFeature": "¿Realmente deseas eliminar esta característica? Esta acción no se puede deshacer.",
    "editModule": "Editar Módulo",
    "importModule": "Importar Módulo",
    "download": "Descargar",
    "edit": "Editar",
    "enableGlobal": "Habilitar Globalmente",
    "chatModulesInfo": "Puedes habilitar o deshabilitar módulos para este chat.",
    "sideMenuRerollButton": "Botón de Regeneración en el Menú Lateral",
    "persistentStorage": "Almacenamiento Persistente",
    "persistentStorageSuccess": "El almacenamiento se ha persistido exitosamente",
    "persistentStorageFail": "El almacenamiento no se ha persistido. ¿Rechazaste la solicitud?, ¿o el navegador no es compatible?",
    "persistentStorageRecommended": "Se recomienda el Almacenamiento Persistente",
    "persistentStorageDesc": "Tu navegador admite almacenamiento persistente. Esto se recomienda para un mejor rendimiento y experiencia del usuario.",
    "enable": "Habilitar",
    "postFile": "Publicar Archivo",
    "requestInfoInsideChat": "Mostrar Información de la Solicitud Dentro del Chat",
    "inputTokens": "Tokens de Entrada",
    "outputTokens": "Tokens de Salida",
    "tokenWarning": "El cálculo de tokens puede ser inexacto. se recomienda usarlo como referencia.",
    "log": "Registro",
    "popularityLevelDesc": "La popularidad aumenta con las descargas, etc. Para estimar, 3.7 de popularidad equivale a aproximadamente 1 descarga.",
    "additionalParams": "Parámetros Adicionales",
    "heightMode": "Modo de Altura",
    "useAdvancedEditor": "Usar Editor Avanzado",
    "noWaitForTranslate": "Sin Espera para Traducir",
    "antiClaudeOverload": "Anti-Sobrecarga de Claude",
    "activeTabChange": "La pestaña actual se desactivó porque otra pestaña está activa. para activar esta pestaña, haz clic en Aceptar",
    "addCharacter": "Agregar Personaje",
    "importFromRealm": "Elegir desde RisuRealm",
    "importFromRealmDesc": "Elige entre más de 1000 personajes en RisuRealm",
    "random": "Aleatorio",
    "metaData": "Meta Data",
    "autoContinueMinTokens": "Tokens Objetivo (Continuar Automáticamente)",
    "autoContinueChat": "Anti-Respuesta Incompleta (Continuar Automáticamente)",
    "removeIncompleteResponse": "Eliminar Frases Incompletas",
    "tokenizer": "Tokenizador",
    "chatFormating": "Formateo de Chat",
    "useInstructPrompt": "Usar Prompt de Instrucción",
    "textAreaSize": "Tamaño del Área de Entrada",
    "textAreaTextSize": "Tamaño del Texto del Área de Entrada",
    "sideBarSize": "Tamaño de la Barra Lateral",
    "embedding": "Embedding",
    "syntax": "Sintaxis",
    "run": "Ejecutar",
    "noMessage": "Escribe algo para comenzar el chat.",
    "combineTranslation": "Combinar Traducción",
    "dynamicAssets": "Activos Dinámicos",
    "dynamicAssetsEditDisplay": "Usar Activos Dinámicos en Visualización",
    "longTermMemory": "Memoria a Largo Plazo",
    "grid": "Cuadrícula",
    "list": "Lista",
    "trash": "Papelera",
    "trashDesc": "Los personajes eliminados se mueven a la papelera. Puedes restaurarlos o eliminarlos permanentemente. Los personajes eliminados se purgan automáticamente después de 3 días.",
    "shareExport": "Compartir/Exportar",
    "risupresetDesc": "El formato Risupreset es un formato específicamente diseñado para presets de RisuBard.",
    "risuMDesc": "El formato RisuM es un formato diseñado específicamente para módulos de RisuBard.",
    "jsonDesc": "El formato JSON es un formato fácil de leer y escribir tanto para humanos como para máquinas.",
    "nickname": "Apodo",
    "useRegexLorebook": "Usar Regex",
    "customPromptTemplateToggle": "Alternar Plantillas Personalizadas",
    "defaultVariables": "Variables Predeterminadas",
    "lowLevelAccess": "Acceso de Bajo Nivel",
    "resultStoredVar": "Variable para Almacenar el Resultado",
    "triggerEffRunLLM": "Ejecutar Modelo Principal",
    "triggerEffectSendAI": "Reenviar IA",
    "triggerEffCheckSim": "Verificar Similitud",
    "triggerEffShowAlert": "Mostrar Alerta",
    "normal": "Normal",
    "error": "Error",
    "input": "Entrada",
    "select": "Seleccionar",
    "options": "Opciones",
    "alertContent": "Contenido de Alerta",
    "lowLevelAccessConfirm": "Este contenido usa Acceso de Bajo Nivel. lo que significa que este contenido puede acceder al modelo de IA y a tu almacenamiento directamente. ¿Realmente deseas importar este contenido?",
    "triggerLowLevelOnly": "Este activador solo funciona con Acceso de Bajo Nivel. para habilitar este activador, habilita Acceso de Bajo Nivel en configuraciones avanzadas en el personaje o módulo.",
    "truthy": "Truthy",
    "extractRegex": "Extraer Texto con Regex",
    "runImgGen": "Ejecutar Generación de Imágenes",
    "cutChat": "Cortar Chat",
    "modifyChat": "Modificar Chat",
    "regex": "Regex",
    "flags": "Flags",
    "resultFormat": "Formato del Resultado",
    "negPrompt": "Prompt Negativo",
    "start": "Inicio",
    "end": "Fin",
    "index": "Índice",
    "search": "Buscar",
    "goCharacterOnImport": "Ir al Personaje al Importar desde Realm",
    "format": "Formato",
    "v2Warning": "Advertencia: La tarjeta V2 ya no es compatible. puede que no contenga todos los datos.",
    "applyModule": "Aplicar Módulo",
    "successApplyModule": "El módulo se aplicó exitosamente",
    "font": "Fuente",
    "lineHeight": "Altura de Línea",
    "loadAutoServerBackup": "Cargar Respaldo Automático del Servidor",
    "notCharxWarn": "Este personaje usa múltiples activos. se recomienda exportar este personaje como un formato CharX para mejor compatibilidad.",
    "noPlugins": "No hay Plugins Instalados",
    "legacyTranslation": "Traducción Legacy",
    "clipboardSuccess": "Copiado al Portapapeles",
    "translateContent": "Traducir Contenido",
    "doNotTranslate": "No Traducir",
    "includePersonaName": "Incluir Nombre de la Persona",
    "hidePersonaName": "Ocultar Nombre de la Persona",
    "triggerSwitchWarn": "Si cambias el tipo de activador, los activadores actuales se perderán. ¿deseas continuar?",
    "codeMode": "Modo Código",
    "blockMode": "Modo Bloque",
    "helpBlock": "Ayuda",
    "hideChatIcon": "Ocultar Icono de UI",
    "loadInternalBackup": "Cargar Respaldo Interno",
    "createCopy": "Crear una Copia",
    "bindPersona": "Vincular Persona",
    "chatOptions": "Opciones de Chat",
    "doYouWantToBindCurrentPersona": "¿Deseas vincular la persona actual a este chat?",
    "doYouWantToUnbindCurrentPersona": "¿Deseas desvincular la persona de este chat?",
    "personaBindedSuccess": "Persona vinculada exitosamente",
    "personaUnbindedSuccess": "Persona desvinculada exitosamente",
    "parameters": "Parámetros",
    "sizeAndSpeed": "Tamaño y Velocidad",
    "useLegacyGUI": "Usar Interfaz Legacy",
    "claudeCachingExperimental": "Claude Caching",
    "openClose": "Abrir/Cerrar",
    "hideApiKeys": "Ocultar Claves API",
    "unformatQuotes": "Desactivar Formato de Citas",
    "enableDevTools": "Habilitar Herramientas de Desarrollo",
    "selectFile": "Seleccionar Archivo",
    "namespace": "Namespace",
    "moduleIntergration": "Integración de Módulos",
    "previewInfo": "Esta vista previa muestra el prompt antes del procesamiento específico del modelo.",
    "miscTools": "Herramientas Varias",
    "promptConvertion": "Conversión de Prompt",
    "convertionStep1": "Selecciona todos los archivos relacionados con el prompt (Contexto, Instrucción y Sampler JSON compatibles)",
    "customCSS": "CSS Personalizado",
    "betaMobileGUI": "GUI Móvil Beta",
    "menu": "Menú",
    "jsonSchema": "Esquema JSON",
    "enableJsonSchema": "Habilitar Esquema",
    "strictJsonSchema": "Esquema Estricto",
    "extractJson": "Extraer JSON",
    "reloadSession": "Se encontró una versión más nueva de los datos guardados. Recargando la sesión...",
    "fixMarkdownNewline": "Arreglar Nueva Línea en Markdown",
    "customQuotes": "Citas Personalizadas",
    "leadingSingleQuote": "Cita Simple Inicial",
    "leadingDoubleQuote": "Cita Doble Inicial",
    "trailingSingleQuote": "Cita Simple Final",
    "trailingDoubleQuote": "Cita Doble Final",
    "translatorNote": "Nota del Traductor",
    "formatGroupInSingle": "Formatear Grupo en Único",
    "groupInnerFormat": "Formato Interno de No Hablante",
    "chatHTML": "HTML del Chat",
    "logShare": "Mostrar Botón de Compartir Registro",
    "preview": "Vista Previa",
    "recommended": "Recomendado",
    "newChat": "Nuevo Chat",
    "predictedOutput": "Salida Predicha",
    "systemContentReplacement": "Reemplazo de Contenido del Sistema",
    "systemRoleReplacement": "Reemplazo de Rol del Sistema",
    "seperateParameters": "Parámetros Separados",
    "seperateParametersEnabled": "Habilitar Parámetros Separados",
    "summarizationPrompt": "Prompt de Resumen",
    "reSummarizationPrompt": "Prompt de Re-Resumen",
    "translatorPrompt": "Prompt de Traducción",
    "translateBeforeHTMLFormatting": "Traducir Antes del Formateo HTML",
    "retranslate": "Retraducir",
    "editTranslation": "Editar traducción",
    "editTranslationSave": "Guardar traducción",
    "exportTranslationCache": "Exportar caché de traducción",
    "exportTranslationCacheSuccess": "Caché de traducción exportada correctamente.",
    "importTranslationCache": "Importar caché de traducción",
    "importTranslationCacheConfirm": "Esto fusionará las entradas en la caché de traducción. Las claves existentes se sobrescribirán. ¿Continuar?",
    "importTranslationCacheSuccess": "Se importaron {0} entradas del caché de traducción.",
    "importTranslationCacheFailed": "Se importaron {0} entradas, pero {1} entradas no se pudieron guardar. El almacenamiento puede estar lleno.",
    "exportTranslationCacheEmpty": "El caché de traducción está vacío.",
    clearTranslationCache: "Borrar caché de traducción",
    clearTranslationCacheSuccess: "Caché de traducción borrada correctamente.",
    clearTranslationCacheConfirm: "Esto eliminará todas las entradas de la caché de traducción. Esta acción no se puede deshacer. ¿Continuar?",
    "loading": "Cargando",
    "autoTranslateCachedOnly": "Traducir Automáticamente Solo Mensajes en Caché",
    "notification": "Notificación",
    "permissionDenied": "Permiso Denegado por tu Navegador o SO",
    "customFlags": "Flags Personalizados",
    "enableCustomFlags": "Habilitar Flags Personalizados",
    "googleCloudTokenization": "Tokenización de Google Cloud",
    "presetChain": "Cadena de Presets",
    "legacyMediaFindings": "Hallazgos de Medios Legacy",
    "staticsDisclaimer": "Las estadísticas se basan en los datos de después de julio de 2024. Los datos pueden no ser precisos.",
    "subtitles": "Subtítulos",
    "subtitlesWarning1": "Debes usar un modelo con entrada de audio/video para usar esta función.",
    "subtitlesWarning2": "Debes usar un modelo con función de transmisión para usar esta función.",
    "reset": "Restablecer",
    "assetMaxDifference": "Diferencia Máxima de Activos",
    "sourceLanguage": "Idioma de Origen",
    "destinationLanguage": "Idioma de Destino",
    "noWebGPU": "Tu navegador o SO no soporta WebGPU. Esto ralentizará el rendimiento significativamente.",
    "menuSideBar": "Barra Lateral del Menú",
    "home": "Inicio",
    "showSavingIcon": "Mostrar Icono de Guardado",
    "pluginVersionWarn": "Esta es la versión {{plugin_version}} del plugin, que no es compatible con esta versión de RisuBard. Por favor, actualiza el plugin a la versión {{required_version}}.",
    "imageTranslation": "Traducción de Imagen",
    "banCharacterset": "Regeneración Automática en Conjunto de Caracteres",
    "realmDirectOpen": "Abrir personaje directamente en RisuRealm",
    "showPromptComparison": "Mostrar Comparación de Prompt",
    "inlayErrorResponse": "Respuesta de Error de Incrustación",
    "triggerOn": "Trigger Activado",
    "noConfig": "Sin Configuración",
    "varName": "Nombre de Variable",
    "var": "Variable",
    "condition": "Condición",
    "trigger": "Trigger",
    "outputVar": "Variable de Salida",
    "source": "Fuente",
    "cmd": "Comando",
    "sysStart": "Inicio del Sistema",
    "sysHistoryEnd": "Fin del Historial del Sistema",
    "sysPromptEnd": "Fin del Prompt del Sistema",
    "target": "Objetivo",
    "addElse": "Agregar Sino",
    "min": "Mín",
    "max": "Máx",
    "delimiter": "Delimitador",
    "deleteCount": "Contador de Eliminación",
    "triggerEffRunAxLLM": "Ejecutar Modelo Auxiliar",
    "hypaV3Settings": {
        "descriptionLabel": "HypaMemory V3 es un sistema de memoria a largo plazo que utiliza tanto resúmenes como búsqueda vectorial.",
        "supaMemoryPromptPlaceHolder": "Dejar en blanco para usar el valor predeterminado",
        "maxMemoryTokensRatioLabel": "Ratio Máximo de Tokens de Memoria (Estimado)",
        "maxMemoryTokensRatioError": "No se puede calcular el ratio máximo de tokens de memoria",
        "memoryTokensRatioLabel": "Ratio de Tokens de Memoria",
        "extraSummarizationRatioLabel": "Ratio de Resumen Adicional",
        "maxChatsPerSummaryLabel": "Mensajes Máximos por Resumen",
        "recentMemoryRatioLabel": "Ratio de Memoria Reciente",
        "similarMemoryRatioLabel": "Ratio de Memoria Similar",
        "randomMemoryRatioLabel": "Ratio de Memoria Aleatoria",
        "enableSimilarityCorrectionLabel": "Activar Corrección de Similitud",
        "preserveOrphanedMemoryLabel": "Preservar Memoria Huérfana",
        "applyRegexScriptWhenRerollingLabel": "Aplicar Script Regex al Regenerar",
        "doNotSummarizeUserMessageLabel": "No Resumir Mensajes del Usuario"
    },
    "hypaV3Modal": {
        "titleLabel": "HypaV3",
        "resetConfirmMessage": "Esta acción no se puede deshacer. ¿Desea restablecer los datos de HypaV3?",
        "resetConfirmSecondMessage": "Esta acción es irreversible. ¿Está realmente seguro de querer restablecer los datos de HypaV3?",
        "convertLabel": "Aún no hay resúmenes, pero puede convertir datos de HypaV2 a V3.",
        "convertButton": "Convertir a V3",
        "convertSuccessMessage": "Datos de HypaV2 convertidos exitosamente a V3",
        "convertErrorMessage": "Error al convertir datos de HypaV2 a V3: {0}",
        "noSummariesLabel": "Aún no hay resúmenes",
        "searchPlaceholder": "Ingrese #N, ID o búsqueda",
        "summaryNumberLabel": "Resumen #{0}",
        "deleteThisConfirmMessage": "¿Eliminar este resumen?",
        "deleteAfterConfirmMessage": "¿Eliminar todos los resúmenes después de este?",
        "deleteAfterConfirmSecondMessage": "Esta acción no se puede deshacer. ¿Está realmente seguro?",
        "translationLabel": "Traducción",
        "rerolledSummaryLabel": "Resumen Regenerado",
        "rerolledTranslationLabel": "Traducción del Resumen Regenerado",
        "connectedMessageCountLabel": "Mensajes Conectados ({0})",
        "connectedFirstMessageLabel": "Primer Mensaje",
        "connectedMessageRoleLabel": "Mensaje de {0}",
        "connectedMessageNotFoundLabel": "Mensaje no encontrado",
        "connectedMessageLoadingError": "Error al cargar mensaje conectado: {0}",
        "connectedMessageTranslationLabel": "Traducción",
        "nextSummarizationFirstMessageLabel": "Primer Mensaje",
        "nextSummarizationNoMessageIdLabel": "Sin ID de Mensaje",
        "nextSummarizationLabel": "HypaV3 resumirá [{0}]",
        "nextSummarizationNoMessagesFoundLabel": "ADVERTENCIA: No se encontraron mensajes",
        "nextSummarizationLoadingError": "Error al cargar el siguiente objetivo de resumen: {0}",
        "summarizationConditionLabel": "Consejo: HypaV3 comienza a resumir cuando los tokens de entrada superan el tamaño máximo de contexto.",
        "emptySelectedFirstMessageLabel": "ADVERTENCIA: El primer mensaje seleccionado está vacío",
        "unclassified": "Sin Clasificar",
        "reSummarize": "Re-resumir",
        "reSummarizing": "Re-resumiendo...",
        "reSummarizeResult": "Resultado de Re-resumen",
        "retry": "Reintentar",
        "translate": "Traducir",
        "tag": "Etiqueta",
        "tagManager": "Gestor de Etiquetas",
        "tagManagerTitle": "Gestor de Etiquetas - Resumen #{0}",
        "newTagName": "Nuevo nombre de etiqueta",
        "noTagsYet": "Aún no hay etiquetas.",
        "addNewTagHint": "Añade una nueva etiqueta arriba.",
        "categoryManager": "Categorías",
        "allCategories": "Todas",
        "categoryName": "Nombre de categoría",
        "noCategoriesYet": "Aún no hay categorías.",
        "addNewCategoryHint": "Haz clic en el botón + arriba para añadir una."
    },
    "bulkEnabling": "Habilitación Masiva de Libro de Lore",
    "showTranslationLoading": "Mostrar Cargando Traducción",
    "showDeprecatedTriggerV1": "Mostrar Trigger V1 Obsoleto",
    "showDeprecatedTriggerV2": "Mostrar Trigger V2 Obsoleto",
    "triggerV1Warning": "El Trigger V1 está obsoleto. podría ser eliminado en el futuro.",
    "copy": "Copiar",
    "paste": "Pegar",
    "depth": "Profundidad",
    "returnCSSError": "Error de CSS devuelto",
    "alwaysActiveInChat": "Siempre Activo (Chat Actual)",
    "childLoreDesc": "Esta es una copia del lore del Personaje que permanece 'Siempre Activo' hasta que se elimine o desactive manualmente en el original.",
    "thinkingTokens": "Tokens de Pensamiento",
    "antiServerOverload": "Anti-Sobrecarga del Servidor",
    "localActivationInGlobalLorebook": "Activación Local en Libro de Lore Global",
    "cachePoint": "Punto de Caché",
    "all": "Todos",
    "showFolderNameInIcon": "Mostrar Nombre de Carpeta en Icono",
    "claudeCachingRetrival": "Recuperación de Caché de Claude",
    "claudeCachingRetrivalDesc": "Extiende el tiempo de caché para Claude Caching, solicitando cada 4 minutos. esto puede reducir la tasa de fallos de caché, pero puede aumentar el costo si no se usa correctamente.",
    "automaticCachePoint": "Punto de Caché Automático",
    "experimentalChatCompression": "Manejo Experimental de Datos de Chat",
    "loadingChatData": "Cargando Datos de Chat",
    "outputImageModal": "Modal de Imagen de Salida",
    "playMessageOnTranslateEnd": "Reproducir Audio al Completar Traducción",
    "auxModelUnderModelSettings": "Mostrar Modelos Auxiliares Separados en Configuración de Modelo",
    "seperateModelsForAxModels": "Modelos Separados para Modelos Auxiliares",
    "axModelsDef": "Definición de Modelos Auxiliares",
    "doNotChangeSeperateModels": "No Cambiar Modelos Separados al Cambiar Preset",
    "tools": "Herramientas",
    "action": "Acción",
    "hotkey": "Tecla de Acceso Rápido",
    "hotkeyDesc": {
        "reroll": "Regenerar",
        "unreroll": "Deshacer Regeneración",
        "translate": "Traducir",
        "remove": "Eliminar",
        "edit": "Editar",
        "copy": "Copiar",
        "send": "Enviar",
        "settings": "Configuración",
        "home": "Inicio",
        "presets": "Selección Rápida de Presets",
        "persona": "Selección Rápida de Persona",
        "modelSelect": "Selección Rápida de Modelo",
        "toggleCSS": "Alternar CSS",
        "prevChar": "Personaje Anterior",
        "nextChar": "Siguiente Personaje",
        "quickMenu": "Menú Rápido",
        "quickSettings": "Configuración Rápida",
        "toggleVoice": "Alternar Voz",
        "toggleLog": "Alternar Registro",
        "previewRequest": "Vista Previa de Solicitud",
        "import": "Importar",
        "export": "Exportar",
        "webcam": "Alternar Webcam",
        "focusInput": "Enfocar Entrada",
        "scrollToActiveChar": "Desplazarse al personaje activo"
    },
    "screenTooSmall": "La pantalla es demasiado pequeña para mostrar la interfaz.",
    "advancedModelSettings": "Configuraciones Avanzadas del Modelo",
    "fallbackModel": "Modelo de Fallback",
    "fallbackWhenBlankResponse": "Fallback Cuando Respuesta en Blanco",
    "doNotChangeFallbackModels": "No Cambiar Modelos de Fallback al Cambiar Preset",
    "customModels": "Modelos Personalizados",
    "igpPrompt": "Prompt IGP",
    "useTokenizerCaching": "Caché de Tokenizador",
    "hypaMemoryV3Modal": "Modal Hypa V3",
    "showMenuHypaMemoryModal": "Mostrar Menú Modal Hypa",
    "promptInfoInsideChat": "Agregar Info de Prompt al Chat",
    "promptTextInfoInsideChat": "Agregar Texto de Prompt al Chat",
    "promptInfoEmptyMessage": "No hay información de prompt disponible para este mensaje.",
    "promptInfoEmptyToggle": "No hay interruptores personalizados activos actualmente.",
    "promptInfoEmptyText": "No se ha guardado texto de prompt.",
    "escapeOutput": "Escapar Salida",
    "claudeBatching": "Batching de Claude",
    "claude1HourCaching": "Caché de Claude de 1 Hora",
    "folderNameInput": "Por favor ingrese el nuevo nombre de la carpeta",
    "folderRemoveLengthError": "Para eliminar una carpeta, no debe contener ninguna entrada.",
    "personaNote": "Nota de Persona",
    "mcpAccessPrompt": "{{tool}} está intentando \"{{action}}\". ¿deseas permitir esto?",
    "rememberToolUsage": "Recordar uso de herramienta",
    "simplifiedToolUse": "Uso simplificado de herramientas",
    "toolCalled": "Herramienta '{{tool}}' Llamada",
    "static": "Estático",
    "dynamic": "Dinámico",
    "assetStyle": "Estilo de Activo",
    "insertAssetPrompt": "Insertar Prompt de Activo",
    "requestLocation": "Ubicación de Solicitud",
    "newImageHandlingBeta": "Nuevo Manejo de Imágenes (Beta)",
    "settingsExported": "Configuración para informe de errores exportada y copiada al portapapeles.",
    "bookmarks": "Marcadores",
    "noBookmarks": "Sin Marcadores",
    "bookmarkAskNameOrDefault": "Ingresa el nombre del marcador. Si no se ingresa, se asignará automáticamente.",
    "bookmarkAskNameOrCancel": "Ingresa el nombre del marcador. Si no se ingresa, se cancelará el cambio de nombre.",
    "collapseAll": "Contraer Todo",
    "expandAll": "Expandir Todo",
    "hideErrorDetails": "Ocultar Detalles del Error",
    "showErrorDetails": "Mostrar Detalles del Error",
    "dynamicOutput": "Salida Dinámica",
    "autoAdjustSchema": "Ajustar Esquema Automáticamente",
    "dynamicMessages": "Mensajes Dinámicos",
    "dynamicMemory": "Memoria Dinámica",
    "dynamicResponseTiming": "Tiempo de Respuesta Dinámico",
    "showTypingEffect": "Mostrar Efecto de Escritura",
    "dynamicRequest": "Solicitud Dinámica",
    "dynamicOutputPrompt": "Prompt de Salida Dinámica",
    "settingsCloseButtonSize": "Tamaño del botón de cerrar configuración",
    "translating": "Traduciendo...",
    "stackTraceTranslationFailed": "La traducción del seguimiento de pila falló. Se muestra abajo el seguimiento de pila ofuscado original.",
    "translate": "Traducir dirección de código",
    "apply": "Aplicar",
    "add": "Agregar",
    "nightlyWarning": "## Builds Nightly\n\nTe estás conectando a una build nightly del software. Esta versión está destinada a pruebas y muy probablemente contiene errores. **En esta versión, incluso si encuentras problemas, no admitimos resolverlos directamente.**",
    "loginSionyw": "Iniciar sesión con cuenta de Sionyw",
    "pluginRiskDetectedAlert": "RisuBard detectó código que puede ser dañino y que podría ROBAR TU CLAVE API O DATOS PERSONALES. te recomendamos NO INSTALAR ESTE PLUGIN.",
    "doNotInstall": "No Instalar",
    "continueAnyway": "Continuar de Todos Modos",
    "pluginNoRiskButAlert": "RisuBard no detectó código dañino, pero ten en cuenta que instalar plugins de fuentes no confiables puede plantear riesgos de seguridad.",
    "pluginRisksInuserFriendly": {
        "eval": "Evaluando Código desde Cadenas",
        "globalAccess": "Accediendo a Variables Globales",
        "thisOutsideClass": "Usando 'this' Fuera del Contexto de Clase",
        "errorInVerification": "Errores Durante el Proceso de Verificación",
        "storageAccess": "Accediendo al Almacenamiento"
    },
    "pluginRisksInuserFriendlyDesc": {
        "eval": "El plugin intenta ejecutar código desde cadenas, las cadenas pueden ser ofuscadas para ocultar código malicioso.",
        "globalAccess": "El plugin intenta acceder a variables globales, lo que puede llevar a efectos secundarios no deseados o vulnerabilidades de seguridad.",
        "thisOutsideClass": "El plugin usa la palabra clave 'this' fuera del contexto de clase, lo que puede llevar a un comportamiento no deseado o problemas de seguridad.",
        "errorInVerification": "Hay errores durante el proceso de verificación del plugin, indicando problemas potenciales con su funcionalidad.",
        "storageAccess": "El plugin intenta acceder al almacenamiento, lo que podría llevar a fugas de datos o manipulación de datos no autorizada."
    },
    "generatedByAIDisclaimer": "Este contenido fue generado por IA y puede contener inexactitudes o sesgos.",
    "aiGenerationWarning": "El contenido será generado por IA y puede contener inexactitudes o sesgos.",
    "loadMore": "Cargar más",
    "goToChat": "Ir al chat",
    "bookmark": "Marcador",
    "duplicatePluginFoundUpdateIt": "Se encontró un plugin duplicado. ¿Desea actualizar el plugin existente?",
    "branchedText": "Este chat se ha ramificado desde {}.",
    "pluginUpdateFoundInstallIt": "Se ha encontrado una actualización del plugin. ¿Desea instalar la actualización?",
    "branch": "Rama",
    "newMessageButtonBottomLeft": "Abajo a la izquierda",
    "newMessage": "Nuevo mensaje",
    "newMessageButtonFloatingCircle": "Círculo flotante (inferior derecha)",
    "newMessageButtonBottomRight": "Abajo a la derecha",
    "newMessageButtonBottomCenter": "Centro inferior (predeterminado)",
    "autoScrollToNewMessage": "Desplazamiento automático al nuevo mensaje",
    "disableMessage": "Desactivar mensaje",
    "newMessageButtonStyle": "Estilo del botón de nuevo mensaje",
    "alwaysScrollToNewMessage": "Desplazarse siempre al nuevo mensaje (ignorar la posición de desplazamiento)",
    "newMessageButtonTopBar": "Barra superior",
    "enableScrollToActiveChar": "Activar desplazamiento al personaje activo",
    "pluginDevelopMode": "Modo de desarrollo de plugins",
    "newMessageButtonRightCenter": "Centro derecha",
    "trimStartNewChat": "Recortar mensajes de «Iniciar nuevo chat»",
    "getFullDatabaseConsent": "El plugin {} está solicitando acceso a la base de datos completa, lo que podría exponer información confidencial. ¿Desea permitir esto?",
    "fetchLogConsent": "El complemento {} está solicitando obtener registros, lo cual podría exponer información confidencial. ¿Desea permitir esto?",
    "mainDomAccessConsent": "El plugin {} está solicitando acceso al Documento principal, lo que podría exponer información confidencial. ¿Desea permitir esto?",
    "replacerPermissionConsent": "El plugin {} está solicitando permiso para reemplazar contenido en el chat, lo que podría usarse para manipular la conversación. ¿Desea permitir esto?",
    "inlayPermissionConsent": "El plugin {} está solicitando permiso para leer recursos incrustados adjuntos a mensajes de chat. ¿Desea permitir esto?",
    "providerPermissionConsent": "El plugin {} está solicitando permiso para acceder al proveedor, lo que podría permitirle realizar llamadas API no autorizadas. ¿Desea permitir esto?",
    "sendChatConsent": "El plugin {} está solicitando permiso para enviar mensajes de chat en su nombre, lo que activará respuestas de IA. ¿Desea permitir esto?",
    "pluginV2Warning": "Los plugins V2 y V2.1 se consideran inseguros y dejarán de funcionar en futuras versiones. **Por favor, no use estas versiones de plugins.** Si usted es el desarrollador de este plugin, actualícelo a V3 lo antes posible.",
    "disableAbove": "Mensajes cortados para la IA",
    "hamburgerButtonBottom": "Mover el botón de menú a la parte inferior de la barra lateral",
    "nanoGPTLoadingAccountInfo": "Cargando información de la cuenta…",
    "nanoGPTCreditBalance": "Saldo de crédito:",
    "nanoGPTSubscription": "Suscripción",
    "nanoGPTGraceUntil": (date: string) => `hasta ${date}`,
    "nanoGPTNoActiveSubscription": "Sin suscripción activa.",
    "nanoGPTCancelsAtPeriodEnd": (date: string) => `Se cancela al final del período (${date})`,
    "nanoGPTWeeklyTokens": (pct: string) => `Tokens de entrada incluidos semanales — ${pct} usados`,
    "nanoGPTDailyTokens": (pct: string) => `Tokens de entrada incluidos diarios — ${pct} usados`,
    "nanoGPTDailyImages": (pct: string) => `Imágenes incluidas diarias — ${pct} usadas`,
    "nanoGPTResets": (date: string) => `Se restablece el ${date}`,
    "nanoGPTUsed": (n: string) => `${n} usados`,
    "nanoGPTRemaining": (n: string) => `${n} restantes`,
    "nanoGPTRenews": (date: string) => `Se renueva: ${date}`,
    "nanoGPTCouldNotLoadAccountInfo": "No se pudo cargar la información de la cuenta.",
    "nanoGPTWeeklyTokensLabel": "Tokens de entrada semanales incluidos",
    "nanoGPTDailyTokensLabel": "Tokens de entrada diarios incluidos",
    "nanoGPTDailyImagesLabel": "Imágenes diarias incluidas",
    "nanoGPTUsedLabel": "usados",
    "nanoGPTRemainingLabel": "restantes",
    "nanoGPTResetsLabel": "Se reinicia",
    "nanoGPTRenewsLabel": "Renovación:",
    "nanoGPTProvider": "Proveedor",
    "nanoGPTProviderPayAsYouGoOnly": "(solo disponible en modo de pago por uso)",
    "nanoGPTProviderAuto": "Auto",
    "nanoGPTProviderFree": "Gratis",
    "nanoGPTProviderInput": "Entrada",
    "nanoGPTProviderOutput": "Salida",
    "nanoGPTProviderQuantization": "Cuantización",
    "nanoGPTProviderUndisclosed": "No revelado",
    "nanoGPTProviderCache": "Caché",
    "nanoGPTProviderCacheSupported": "Compatible",
    "nanoGPTProviderCacheNotSupported": "No compatible",
    "nanoGPTProviderCacheRead": "Lectura de caché",
    "nanoGPTUseSubscriptionEndpoint": "Usar endpoint y modelos de suscripción",
    "modelGridCouldNotLoad": "No se pudo cargar la lista de modelos. Verifique su clave API.",
    "modelGridNoModelsMatch": (q: string) => `Ningún modelo coincide con "${q}"`,
    "modelGridContext": (n: string) => `Contexto: ${n}`,

    nanoGPTSelectFromList: "Seleccionar de la lista",
    nanoGPTManualInput: "Entrada manual",
    nanoGPTManualModelSelect: "Selección manual de modelo",

    remoteAccessTermuxWarning: "Cloudflare Quick Tunnel no funciona en Termux. Utiliza Tailscale u otra herramienta de acceso remoto.",

    httpInsecureWarningTitle: "Conectado mediante HTTP",
    httpInsecureWarningBody: "Algunas funciones como los plugins pueden no funcionar. Usa la función de Acceso Remoto para una conexión HTTPS.",
    httpInsecureOpenRemoteAccess: "Abrir configuración",

    selectBotHint: "Selecciona un bot para empezar a chatear",
} satisfies DeepPartial<typeof import('./en').languageEnglish>;
